const _excluded = ["title", "children", "togglePanelView", "isOpen", "setIsOpen"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import { useEffect, useState } from 'react';
import cn from 'classnames';
import { IconButton, Typography, useDevice } from 'seagull';
import { WideArrowDownward, WideArrowUpward } from 'seagull/icons';
import styles from "./FormlingContainer.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function FormlingContainer(_ref) {
  let {
      title,
      children,
      togglePanelView = false,
      isOpen = false,
      setIsOpen
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const [showChildren, setShowChildren] = useState(!togglePanelView || isOpen);
  const {
    isMobileDevice
  } = useDevice();
  useEffect(() => {
    if ((!togglePanelView || isOpen) !== showChildren) {
      setShowChildren(!togglePanelView || isOpen);
    }
    // eslint-disable-next-line react-hooks-static-deps/exhaustive-deps
  }, [isOpen, togglePanelView]);
  function toggle() {
    if (togglePanelView) {
      setShowChildren(!showChildren);
      setIsOpen === null || setIsOpen === void 0 || setIsOpen(!showChildren);
    }
  }
  return /*#__PURE__*/_jsxs("section", {
    className: cn(styles.container, {
      [styles.mobile]: isMobileDevice
    }),
    children: [/*#__PURE__*/_jsxs("div", {
      className: cn(styles.titleContainer, togglePanelView && styles.clickableHeader),
      onClick: toggle,
      "data-testid": rest['data-testid'] && "".concat(rest['data-testid'], "-header"),
      children: [/*#__PURE__*/_jsx(Typography, {
        variant: "h5",
        weight: "normal",
        className: styles.title,
        children: title
      }), togglePanelView && /*#__PURE__*/_jsx("span", {
        className: styles.menuButtonContainer,
        children: /*#__PURE__*/_jsx(IconButton, {
          children: showChildren ? /*#__PURE__*/_jsx(WideArrowUpward, {}) : /*#__PURE__*/_jsx(WideArrowDownward, {})
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      hidden: !showChildren,
      "data-testid": rest['data-testid'] && "".concat(rest['data-testid'], "-content"),
      className: styles.content,
      children: children
    })]
  });
}